import React from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import TrackOrder from "../components/profile/TrackOrder";

const TrackOrderPage = () => {
  return (
    <div>
      <Header />
      <TrackOrder />
      <Footer />
    </div>
  );
};

export default TrackOrderPage;
